import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DropdownSelect } from "../../../core/components/dropdown/DropdownSelect";
import { InfoText } from "../../../core/components/texts/InfoText";
import { getLanguage } from "../../../core/store/appSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { reloadIfDeferred } from "../../../core/utils/useRefreshOutdatedApp";
import { OnboardingScreenContainer } from "../../onboarding/OnboardingScreenContainer";

export const OnboardingInfoScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // A version reload deferred during the SMS login runs once the patient is back here (PF-6132).
  useEffect(() => reloadIfDeferred(), []);
  // The next step's code, loaded while the patient reads this screen.
  useEffect(() => {
    void import("./OnboardingLoginScreen");
  }, []);

  const handleNext = async () => {
    navigate(`/welcome/login`);
  };
  const language = useMainStore(getLanguage);
  const setLanguage = useMainStore((state) => state.setLanguage);

  const languageOptions = [
    { value: "de", label: "Deutsch" },
    { value: "tr", label: "Türkçe" },
    { value: "en", label: "English" },
  ];

  const selectedLanguageOption =
    languageOptions.find((option) => option.value === language)?.label ||
    languageOptions[0].label;

  return (
    <OnboardingScreenContainer
      hideBackButton
      nextButton={{
        onClick: handleNext,
      }}>
      <InfoText
        headline={t("ONBOARDING_HEADLINE")}
        text={[t("ONBOARDING_DESCRIPTION")]}
      />
      <DropdownSelect
        value={selectedLanguageOption}
        options={languageOptions}
        onChange={(_label, value) => {
          setLanguage(
            value as
              | "de"
              | "en"
              | "tr"
              | "cs"
              | "ru"
              | "hr"
              | "es"
              | "fr"
              | "it"
              | "sq",
          );
        }}
        withoutError
      />
    </OnboardingScreenContainer>
  );
};
